export const ROUTE_NAMES = {
  AGENTS: {
    BASE: 'agenti',
    LIST: 'lista',
    DETAIL: 'dettaglio',
    WALLETS_HISTORY: 'storico-borsellini',
    WALLETS_LIST: 'lista-borsellini',
    COMPANY_WALLETS_LIST: 'lista-borsellini-azienda',
    CUSTOMER_LIST: 'lista-clienti',
    AGENT_CUSTOMER_LIST: 'lista-clienti-agente',
    CUSTOMER_DETAIL: 'dettaglio-cliente',
    CUSTOMER_DISCOUNTS: 'sconti-cliente',
  },
  ORDERS: {
    BASE: 'ordini',
    LIST: 'lista',
  },
  CATEGORIES: {
    BASE: 'categorie',
    LIST: 'lista',
    CATEGORIES_LIST: 'lista-categorie',
    DETAIL: 'dettaglio',
    POINTS: 'punti',
  },
  PRODUCTS: {
    BASE: 'prodotti',
    LIST: 'lista-prodotti',
    CUSTOMER_DISCOUNTS: 'sconti-cliente',
    POINTS: 'punti',
  },
  MARKETING: {
    BASE: 'promozioni',
    LIST: 'lista',
    DOCUMENTS: 'documenti',
    FORUM: 'forum',
    PUSH_NOTIFICATIONS: 'notifiche-push',
  },
  APP: {
    BASE: 'app',
    POINTS: {
      BASE: 'punti',
      CATEGORIES: 'categorie',
      PRODUCT: 'prodotto',
    },
    GIFT_CATALOGUE: {
      BASE: 'catalogo-premi',
      LIST: 'lista',
      DETAIL: 'dettaglio',
    },
    FEATURED_PRODUCTS: 'prodotti-evidenza',
    RELATED_PRODUCTS: 'prodotti-correlati',
    APP_POINTS: 'puntiapp',
    VERSIONS: 'app-versions',
    MARKETPLACE_ANNOUNCEMENTS: 'annunci-mercatino',
    MARKETPLACE_CATEGORIES: 'categorie-app',
  },
  USERS: {
    BASE: 'user-management',
    LIST: 'lista',
  },
  REPORTS: {
    BASE: 'report',
    LIST: 'lista',
  },
  ACCOUNTING: {
    BASE: 'accounting',
    ACCOUNT_STATEMENT: 'estratto-conto',
  },
  MAINTENANCE_CATEGORIES: {
    BASE: 'gestione-categorie-manutenzione',
    LIST: 'lista',
  },
};
